module.exports = function(app) {
	'use strict'
	app.directive('categoryAccordion',categoryAccordion);
	categoryAccordion.$inject=['$timeout','refreshtokenService','alertService','serverError','config','postDataService','getDataService','jQuery'];
	function categoryAccordion($timeout, refreshtokenService, alertService,serverError, config, postDataService, getDataService, jQuery) {
		return {
			restrict: 'E',
			scope:{
				parent:'=',
				categories:'=',
				parentCategory:'=',
				open:'='
			},
			replace:true,
			template: require('./partial/categoryAccordion.html'),
			link: function(scope, ele, $attrs, ctrl) {
				var parentCategoriesFunc= function(parent,onLoad) {
					if(parent.parentCategory) {
						scope.parent.parentCategoriesChecked[parent.parentCategory._id] = true
						if(onLoad) {
							parent.parentCategory.open = true;
							if(!parent.parentCategory.visible) {
								parent.parentCategory.visible= true;
							}
						}
					}
					if(parent.$parent) {
						if(onLoad) {
							parentCategoriesFunc(parent.$parent,true)
						} else {
							parentCategoriesFunc(parent.$parent)
						}
					}
				}
				scope.$watch(function(){
					return scope.parent.categoryIdOnLoad
				  }, function(newValue, oldValue){
					if (newValue && newValue !== oldValue) {
						if(scope.categories && scope.categories.length>0) {
							onloadLoop:
							for (var i=0; i<scope.categories.length; i++){
								if(scope.categories[i]._id == newValue) {
									scope.parent.categorychecked[newValue] = true;
									scope.parent.category = newValue;
									if(!scope.categories[i].visible) {
										scope.categories[i].visible = true;
									}
									if(scope.parentCategory) {
										scope.parent.parentCategoriesChecked[scope.parentCategory._id]=true;
										scope.parentCategory.open = true;
										if(!scope.parentCategory.visible) {
											scope.parentCategory.visible = true;
										}
										parentCategoriesFunc(scope.$parent, true)
									}
									$timeout(function() {
										var checkedCategory = jQuery(".checkedEditPost");
										if(checkedCategory.length != 0) {
											var topPos = checkedCategory[0].offsetTop;
											jQuery('#categoryscroll').animate({scrollTop: topPos-2},600);
										}
									},300)
									break onloadLoop
								}
							}
						}
					}
					
				},true);
				scope.updateSelection = function(category_id, checked, categoryObj,event) {
					if(categoryObj.children && categoryObj.children.length > 0) {
					  	event.preventDefault();
					  	categoryObj.open = !categoryObj.open
					  	return
					};
					var updateSelectionTree = function(categories) {
					  	if(checked) {
							scope.parent.parentCategoriesChecked = {}
							scope.parent.categorychecked = {};
							for (var i=0; i<categories.length; i++){
								if (categories[i]._id === category_id) {
									scope.parent.categorychecked[category_id] = true;
									scope.parent.category = category_id;
									if(scope.parentCategory) {
										scope.parent.parentCategoriesChecked[scope.parentCategory._id]=true;
										parentCategoriesFunc(scope.$parent)
									}
									break
								}
							}
					  	} else {
							scope.parent.category = null;
							scope.parent.categorychecked = {};
							scope.parent.parentCategoriesChecked= {};
					  	}
					}
					updateSelectionTree(scope.categories);   
				}
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/categoryAccordion/categoryAccordionDirective.js
// module id = 435
// module chunks = 0